import { Switch, Typography } from "antd";
import type { SubjectEntity } from "../../Processing/types";
import { PlayersForm } from "../shared/PlayersForm";
import type { PieSliceState } from "./pieState";
import { isSectionBindable } from "../../Processing/controllerBindings";

const { Text } = Typography;

interface PieSubjectPanelProps {
  slice: PieSliceState;
  onPatch: (patch: Partial<PieSliceState>) => void;
  getSubjectEntities: (type: string) => SubjectEntity[];
}

export function PieSubjectPanel({ slice, onPatch, getSubjectEntities }: PieSubjectPanelProps) {
  return (
    <div className="awm-step-body">
      <PlayersForm
        bindable={isSectionBindable("pie_chart", "subject")}
        value={slice}
        onChange={onPatch}
        getSubjectEntities={getSubjectEntities}
        hideDrills={!!slice.countSpec}
        description={
          slice.countSpec
            ? "Choose which athletes to include in this slice."
            : "Choose which athletes or drills to include in this slice."
        }
      />
      <div
        style={{
          display: "flex", justifyContent: "space-between", alignItems: "flex-start",
          padding: "8px 10px", border: "1px solid #e0e5eb", borderRadius: 8, background: "#fafbfc",
        }}
      >
        <div>
          <Text strong style={{ fontSize: 12 }}>Exclude Injured Players</Text>
          <br />
          <Text type="secondary" style={{ fontSize: 11 }}>
            Exclude injured athletes from this value.
          </Text>
        </div>
        <Switch
          size="small"
          checked={slice.excludeInjuredPlayers}
          onChange={(v) => onPatch({ excludeInjuredPlayers: v })}
        />
      </div>
    </div>
  );
}
